import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import RelatorioComparativoView from './RelatorioComparativoView';
import RelatoriosMainPage from './RelatoriosMainPage';
import HistoricoCustosProjetosClientesView from './HistoricoCustosProjetosClientesView'
import ComparativoFaturamentoView from './ComparativoFaturamentoView';
import ResultadoAnualProjeto from './ResultadoAnualProjetoView';
import RelatorioCapacidadeView from './RelatorioCapacidadeView';
import RelatorioCapacidadeProjetoView from './RelatorioCapacidadeProjetoView';
import FluxoCaixaView from './FluxoCaixaView';
//import RelatorioRealizadosPlanejadosView from './RelatorioRelacaoProjetoView';
import ChatBotView from './ChatBotView';
import ResultadoDoClienteView from './ResultadoDoClienteView';
import RelatorioTurnoverView from './RelatorioTurnover';
import RelatorioHistoricoCapacidadeView from './RelatorioHistoricoCapacidadeView';
import RelatorioPontoJiraView from './RelatorioPontoJiraView';
import RelatorioHorasExtrasView from './RelatorioHorasExtrasView';
import RelatorioRelacaoHorasView from './RelatorioRelacaoHorasView';
import RelatorioHistoricoHorasExtrasView from './RelatorioHistoricoHorasExtrasView';
import RelatorioBancoDeHorasView from './RelatorioBancoDeHorasView';

function RelatoriosDelivery() {
    const match = useRouteMatch();
    
    return (
        <Switch>
        <Route path={`${match.path}`} exact component={RelatoriosMainPage} />
        <Route path={`${match.path}/comparativo-custo/:key/:id/:dataInicial/:dataFinal`} exact component={RelatorioComparativoView} />
        <Route path={`${match.path}/comparativo-faturamento/:key/:id/:dataInicial/:dataFinal`} exact component={ComparativoFaturamentoView} />
        <Route path={`${match.path}/historico-custos`} exact component={HistoricoCustosProjetosClientesView} />
        <Route path={`${match.path}/resultado-projeto/:key/:id/:radioPeriodo`} exact component={ResultadoAnualProjeto} />
        <Route path={`${match.path}/relatorio-capacidade-area`} exact component={RelatorioCapacidadeView} />
        <Route path={`${match.path}/relatorio-capacidade-projeto`} exact component={RelatorioCapacidadeProjetoView} />
        <Route path={`${match.path}/relatorio-fluxo-caixa`} exact component={FluxoCaixaView} />
        <Route path={`${match.path}/relatorio-resultados/:clienteSelecionadoNome`} exact component={ResultadoDoClienteView} />
        <Route path={`${match.path}/relatorio-turnover`} exact component={RelatorioTurnoverView} />
        <Route path={`${match.path}/relatorio-historico-capacidade`} exact component={RelatorioHistoricoCapacidadeView} />
        <Route path={`${match.path}/comparativo-ponto-jira`} exact component={RelatorioPontoJiraView} />
        <Route path={`${match.path}/comparativo-horas-extras`} exact component={RelatorioHorasExtrasView} />
        <Route path={`${match.path}/comparativo-relacao-horas`} exact component={RelatorioRelacaoHorasView} />
        <Route path={`${match.path}/relatorio-historico-horas-extras`} exact component={RelatorioHistoricoHorasExtrasView} />
        <Route path={`${match.path}/relatorio-banco-de-horas`} exact component={RelatorioBancoDeHorasView} />
        {/* <Route path={`${match.path}/realizados-planejados`} exact component={RelatorioRealizadosPlanejadosView} /> */}
        <Route path={`${match.path}/chat-bot`} exact component={ChatBotView} />
        <Redirect path="*" to="/" />
    </Switch>
    )
}

export default RelatoriosDelivery;
